import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ExprUtils } from '@/common/utils/ExprUtils';

export const PolFormulaForm = () => {
  const { entityObj } = useEntityMgr();

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.incDataSrcId.expr = ExprUtils.whereParams('polId', entityObj.polId);
  };

  return <EntityForm augFieldDefs={augFieldDefs} />;
};
